var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1847 9.49993L5.6698 7.99988V19.0841C5.6699 19.2046 5.69372 19.3238 5.73989 19.435C5.78607 19.5462 5.8537 19.6472 5.93891 19.7323C6.02413 19.8174 6.12527 19.8848 6.23656 19.9308C6.34785 19.9768 6.46711 20.0004 6.58753 20.0003H21.2804C21.4009 20.0006 21.5203 19.9772 21.6318 19.9313C21.7433 19.8854 21.8446 19.8179 21.93 19.7328C22.0154 19.6477 22.0831 19.5466 22.1294 19.4353C22.1757 19.324 22.1995 19.2047 22.1996 19.0841V15.0001L14.1847 9.49993Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1847 -0.000243818H6.58753C6.46711 -0.000344881 6.34785 0.0232728 6.23656 0.0692609C6.12527 0.115249 6.02413 0.182707 5.93891 0.267783C5.8537 0.352859 5.78607 0.453887 5.73989 0.565098C5.69372 0.67631 5.6699 0.795528 5.6698 0.915944V4.99994L14.1847 10.0001L18.6934 11.5002L22.1996 10.0001V4.99994L14.1847 -0.000243818Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.6698 5H14.1847V10.0002H5.6698V5Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.1,
    d: "M11.7639 3.99902H5.6698V16.4995H11.7639C12.0067 16.4983 12.2393 16.4014 12.4112 16.2299C12.5831 16.0585 12.6805 15.8261 12.6824 15.5833V4.91521C12.6805 4.67239 12.5831 4.44006 12.4112 4.26856C12.2393 4.09707 12.0067 4.00023 11.7639 3.99902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M11.2631 4.50037H5.6698V17.0008H11.2631C11.5059 16.9996 11.7385 16.9028 11.9104 16.7313C12.0823 16.5598 12.1798 16.3275 12.1816 16.0846V5.41655C12.1798 5.17373 12.0823 4.9414 11.9104 4.76991C11.7385 4.59842 11.5059 4.50157 11.2631 4.50037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M11.2631 4.50037H5.6698V16.0008H11.2631C11.5059 15.9996 11.7385 15.9027 11.9104 15.7313C12.0823 15.5598 12.1798 15.3274 12.1816 15.0846V5.41655C12.1798 5.17373 12.0823 4.9414 11.9104 4.76991C11.7385 4.59842 11.5059 4.50157 11.2631 4.50037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M10.7623 4.50037H5.6698V16.0008H10.7623C11.0051 15.9996 11.2377 15.9027 11.4096 15.7313C11.5815 15.5598 11.679 15.3274 11.6808 15.0846V5.41655C11.679 5.17373 11.5815 4.9414 11.4096 4.76991C11.2377 4.59842 11.0051 4.50157 10.7623 4.50037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M1.57914 4.50037H10.7626C11.0058 4.50016 11.2392 4.59655 11.4114 4.76835C11.5837 4.94014 11.6806 5.17329 11.6811 5.41656V14.5846C11.6806 14.8279 11.5837 15.061 11.4114 15.2328C11.2392 15.4046 11.0058 15.501 10.7626 15.5008H1.57914C1.45866 15.501 1.33932 15.4774 1.22794 15.4315C1.11656 15.3855 1.01533 15.3181 0.930031 15.233C0.844731 15.1479 0.777034 15.0469 0.730812 14.9356C0.684589 14.8243 0.660745 14.7051 0.660645 14.5846V5.41656C0.660745 5.29607 0.684589 5.17679 0.730812 5.06553C0.777034 4.95427 0.844731 4.85321 0.930031 4.76812C1.01533 4.68304 1.11656 4.61559 1.22794 4.56965C1.33932 4.52371 1.45866 4.50017 1.57914 4.50037Z",
    fill: "url(#paint0_linear_13_2360)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.50684 12.9819L5.43845 9.99407L3.66915 7.02319H5.08997L6.05539 8.92557C6.14463 9.10558 6.20924 9.23943 6.23848 9.32866H6.25155C6.31463 9.18404 6.38156 9.04481 6.45156 8.90865L7.48391 7.02627H8.79165L6.97696 9.98023L8.8378 12.9842H7.44621L6.33079 10.8987C6.279 10.8091 6.23499 10.7151 6.19924 10.6179H6.18078C6.14826 10.7126 6.10489 10.8032 6.05155 10.888L4.90304 12.9819H3.50684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.2815 -0.000242849H14.1851V4.99994H22.2V0.915945C22.1999 0.795464 22.176 0.676183 22.1298 0.564921C22.0836 0.453659 22.0159 0.352597 21.9306 0.267511C21.8453 0.182425 21.7441 0.114984 21.6327 0.0690409C21.5213 0.0230981 21.402 -0.000445042 21.2815 -0.000242849Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.1851 10.0002H22.2V15.0004H14.1851V10.0002Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_2360",
    x1: 2.57918,
    y1: 3.78034,
    x2: 9.76252,
    y2: 16.2208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.58bd57183a42972b58baa3dfdf6ee355.svg";
export { ForwardRef as ReactComponent };